// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"608ff46b","408":"346d9b2f","796":"4644a6b3","916":"d99629e1"}[chunkId] + ".chunk.js";
};